import React, { useRef } from "react";
import {
  Box,
  Text,
  VStack,
  HStack,
  Image,
  Center,
  Divider,
  Flex,
  Button,
} from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const numberToWords = (num) => {
  const a = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const b = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const inWords = (n) => {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + " " + a[n % 10];
    if (n < 1000)
      return a[Math.floor(n / 100)] + " Hundred " + inWords(n % 100);
    if (n < 100000)
      return inWords(Math.floor(n / 1000)) + " Thousand " + inWords(n % 1000);
    if (n < 10000000)
      return inWords(Math.floor(n / 100000)) + " Lakh " + inWords(n % 100000);
    return (
      inWords(Math.floor(n / 10000000)) + " Crore " + inWords(n % 10000000)
    );
  };

  return inWords(Number(num)) + " Rupees Only";
};

const ProvisionalReceipt = () => {
  const pdfRef = useRef();

  const handleDownload = async () => {
    const element = pdfRef.current;
    const canvas = await html2canvas(element, {
      useCORS: true,
      allowTaint: true,
      backgroundColor: null,
      scale: 2,
      width: 794,
      height: 1123,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("provisional_receipt.pdf");
  };

  return (
    <>
      <Box
        ref={pdfRef}
        width="794px"
        height="1123px"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        bg="white"
        py={4}
        px={6}
        backgroundImage="url('https://res.cloudinary.com/dzz32ksnf/image/upload/v1746430660/Screenshot_2025-05-05_130723_rwcfik.png')"
        backgroundSize="cover"
        backgroundRepeat="no-repeat"
        backgroundPosition="center"
        m="auto"
      >
        <Box>
          <Flex
            alignItems="center"
            justifyContent="center"
            gap={4}
            flexWrap="wrap"
          >
            <Image
              src="https://res.cloudinary.com/dzz32ksnf/image/upload/v1746433025/lss_logo.89bae2c852b508839c31_vxcb2v.png"
              alt="Trust Logo"
              boxSize="80px"
              crossOrigin="anonymous"
            />
            <VStack>
              <Text fontSize="2xl" fontWeight="bold" color="#1f3c88">
                LATE SURESH SINGH FOUNDATION<sup>®</sup> TRUST
              </Text>
              <Text fontSize="lg" color="orange" fontWeight="bold">
                Prosperous society-prosperous country
              </Text>
              <Text fontSize="lg" color="black">
                B-18 , 3rd Floor , Satija House , Mukherjee Nagar , Delhi-110009
              </Text>
            </VStack>
          </Flex>
          {/* <Center> */}
          <Text textAlign={"center"} fontSize="2xl" fontWeight="bold">
            RECEIPT
          </Text>
          {/* </Center> */}
          <Divider />
          <WatermarkBox />
        </Box>

        <Footer />
      </Box>

      <Center mt={6}>
        <Button colorScheme="orange" onClick={handleDownload}>
          Download PDF
        </Button>
      </Center>
    </>
  );
};

export default ProvisionalReceipt;

const WatermarkBox = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const recId = queryParams.get("recId") || "N/A";
  const name = queryParams.get("name") || "Testing";
  const amount = queryParams.get("amount") || "0";
  const mode = queryParams.get("mode") || "BILLDESK";
  const orderNo = queryParams.get("orderId") || "N/A";
  const purpose = decodeURIComponent(
    queryParams.get("purpose") || "General Help",
  );
  const email = queryParams.get("email") || "Not provided";
  const txnDate = new Date().toLocaleString();
  const pan = "AACTL2323D";

  console.log("Query Params:", Object.fromEntries(queryParams.entries()));
  return (
    <Box
      h="60vh"
      w="100%"
      maxW="600px"
      m="50 auto"
      p={1}
      bg="transparent"
      fontSize="md"
      fontFamily="sans-serif"
    >
      <VStack p={10} spacing={4} align="start">
        <HStack justify="space-between" w="100%">
          <Text>
            <strong>Rec ID :</strong> {recId}
          </Text>
          <Text>
            <strong>Date:</strong> {txnDate}
          </Text>
        </HStack>
        <Text>
          <strong>Name :</strong> {name}
        </Text>
        <Text>
          <strong>Amount :</strong> ₹{amount}
        </Text>

        <Text fontStyle="italic" color="gray.600">
          ({numberToWords(amount)})
        </Text>
        <Text>
          <strong>Mode :</strong> {mode}
        </Text>
        <Text>
          <strong>Order No :</strong> {orderNo}
        </Text>
        <Text>
          <strong>1. Purpose :</strong> Society Empowerment
        </Text>
        <Text>
          <strong>Email :</strong> {email}
        </Text>
        <Text>
          <strong>Late Suresh Singh Foundation PAN NO. :</strong> {pan}
        </Text>
        <Text>
          <strong>Reg. No. :</strong> DL/2023/0352675
        </Text>
        <Text>
          <strong>80G Registration Number :</strong> AACTL2323DF20231
        </Text>
        <Text>
          <strong>12A Registration Number :</strong> AACTL2323DE20221
        </Text>
      </VStack>
    </Box>
  );
};

const Footer = () => {
  return (
    <Box>
      <Box w="100%" align="center">
        <Text fontSize="xl" fontWeight="bold" color="green.600">
          🙏 Thank you for your generous donation. A prosperous society builds a
          prosperous country.
        </Text>
      </Box>
      <Box mt={4} bg="transparent" borderTop="4px solid orange" py="2">
        <Flex
          align="center"
          justify="center"
          direction="row"
          wrap="nowrap"
          px="4"
        >
          <Image
            src="https://res.cloudinary.com/dzz32ksnf/image/upload/v1746435176/WhatsApp_Image_2025-05-02_at_17.33.49_3596f7fa-removebg-preview_giq9t0.png"
            alt="left hand"
            boxSize="70px"
            objectFit="contain"
          />
          <Text
            fontSize="lg"
            mx="4"
            textAlign="center"
            color="black"
            fontWeight="bold"
          >
            011-42875447 | 09910174777 | lssftrust@gmail.com |
            www.lsstrust.org.in
          </Text>
          <Image
            src="https://res.cloudinary.com/dzz32ksnf/image/upload/v1746186938/pngwing.com_39_2_e3sq5a.png"
            alt="right hand"
            boxSize="70px"
            objectFit="contain"
          />
        </Flex>
      </Box>
    </Box>
  );
};
